// tailwind
import "tailwindcss/dist/base.min.css"

// Highlighting for code blocks
import "prismjs/themes/prism.css"
